import { render, staticRenderFns } from "./SyncStep.vue?vue&type=template&id=6f6cc96f"
import script from "./SyncStep.vue?vue&type=script&lang=js"
export * from "./SyncStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports